import { render } from "./BaseInvoice.vue?vue&type=template&id=092ddc93&scoped=true"
import script from "./BaseInvoice.vue?vue&type=script&lang=js"
export * from "./BaseInvoice.vue?vue&type=script&lang=js"

import "./BaseInvoice.vue?vue&type=style&index=0&id=092ddc93&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-092ddc93"]])

export default __exports__